export const NONE = 'none';
export const ITX_CHEAPER = 'ITX Cheaper';
export const NOT_AVAILABLE = 'Not Available';
export const PRICE_DECREASE = 'Price Decrease';
export const PRICE_INCREASE = 'Price Increase';
export const RETAIL_CHEAPER = 'Retail Cheaper';
